import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { Router  } from '@angular/router';

import { Login } from "./login";
import 'rxjs/add/operator/debounceTime';
import { AuthService } from "../../auth.service";
import { AppCommonService } from "../../appcommon.service";
import { GlobalService } from "../../global.service";
import { LoaderService } from "../../LoaderService";
declare var $: any;

@Component({
    selector:'[mft-login]',
    templateUrl:'./login.component.html'    
})
export class LoginComponent implements OnInit{
    loginForm: FormGroup;
    login: Login = new Login();
    errorMessage: string;
    public loading = false;
    //@ViewChild('loginAreaClick') loginAreaClick: ElementRef;

    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private appCommonService: AppCommonService,
        private router: Router,
        public globalService: GlobalService,
        public loaderService: LoaderService
    ) { }

    ngOnInit(): void {
        this.loginForm = this.fb.group({
            username: ['', [Validators.required]],
            password: ['', [Validators.required]]
        });
    }

    logIn(): void {
        if (this.loginForm.dirty && this.loginForm.valid) {
            // Copy the form values over the product object values
            let p = Object.assign({}, this.login, this.loginForm.value);            
          this.loaderService.display(true);
          //debugger
            this.authService.obtainAccessToken(p)
            .subscribe(
                () => {
                    this.onLoginComplete();                    
                    this.loaderService.display(false);
                    this.redirectToRelevantAccessArea();                    
                },
                (error: any) => {
                    this.loaderService.display(false);
                    this.globalService.showError("Login",<any>error)
                }
            );
        } else if (!this.loginForm.dirty) {
            this.onLoginComplete();
        }
    }

    redirectToRelevantAccessArea():void{
        this.router.navigate([this.appCommonService.reDirectURL]);
    }

    onLoginComplete(): void {
        // Reset the form to clear the flags
        this.loginForm.reset();
        this.errorMessage = '';
    }

    ngAfterViewInit(){
        //let el: HTMLElement = this.loginAreaClick.nativeElement as HTMLElement;
        //this.appCommonService.setLoginMenuElement(el);
    }
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/login/login.comonent.ts